import ChangelogEvent from './ChangelogEvent'
export default ChangelogEvent
